import { useState } from "react";
import { useParams } from "react-router-dom";
import ClientEdit from "../../components/clientEdit/ClientEdit";
import ClientTap from "../../components/clientTap/ClientTap";
import ClientHistory from "../../components/clientHistory/ClientHistory";
import ContractEdit from "../../components/contractEdit/ContractEdit";
import TableContract from "../../components/tableContract/TableContract";
import ClientMenu from "../../components/clientMenu/ClientMenu";
import ClientReferrals from "../../components/clientReferrals/ClientReferrals";
import ClientCardInformation from "../../components/clientCardInformation/ClientCardInformation";

const ClientEditPage = () => {
  const { clientId, contractId } = useParams();
  const [tapSelected, setTapSelected] = useState(1);

  const renderContent = () => {
    const content = {
      1: <ClientEdit clientId={clientId} />,
      2: <TableContract customerId={clientId} />,
      3: <ClientHistory clientId={clientId} />,
      4: <ContractEdit contractId={contractId} />,
      5: <ClientReferrals clientId={clientId} />,
      6: <ClientCardInformation clientId={clientId} />,
    };
    return content[tapSelected] || null;
  };

  return (
    <ClientMenu>
      <ClientTap
        tapSelected={tapSelected}
        handleChangeTap={setTapSelected}
        clientId={clientId}
      />
      {renderContent()}
    </ClientMenu>
  );
};

export default ClientEditPage;
